'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 20px;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  ', ';\n  background-image: ', ';\n  pointer-events: none;\n  z-index: 1;\n'], ['\n  width: 20px;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  ', ';\n  background-image: ', ';\n  pointer-events: none;\n  z-index: 1;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n          left: 42px;\n        '], ['\n          left: 42px;\n        ']),
    _templateObject3 = _taggedTemplateLiteral(['\n          right: 42px;\n        '], ['\n          right: 42px;\n        ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Gradient = _styledComponents2.default.div(_templateObject, function (_ref) {
  var left = _ref.left;
  return left ? (0, _styledComponents.css)(_templateObject2) : (0, _styledComponents.css)(_templateObject3);
}, function (_ref2) {
  var left = _ref2.left;
  return 'linear-gradient(to ' + (left ? 'left' : 'right') + ', rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))';
});

Gradient.propTypes = {
  left: _propTypes2.default.bool
};
Gradient.defaultProps = {
  left: false
};
exports.default = Gradient;